<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <!-- <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link :to="{ path: '/DischargePermissions/Create' }">
              <vs-button
                class="bg_l_green"
                v-has-permission="permission120"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("CreateDischargePermission") }}
              </vs-button>
            </router-link>
          </div>
        </div> -->
        <vx-card>
          <vs-tabs vs-alignment="fixed" alignment="fixed" ref="Tabs">
            <vs-tab
              :label="$t('DraftOrderWaitingForDischargePermissionSubmission')"
              class="mt-1"
              v-if="waitingForDischargePermissionSubmissionPermission"
            >
              <waiting-for-discharge-permission-submission
                :tabIndex="0"
                v-if="isRender[0]"
                :numberRowsPerPage="numberRowsPerPage"
              ></waiting-for-discharge-permission-submission>
            </vs-tab>
            <vs-tab
              :label="$t('Pending')"
              class="mt-1"
              v-if="pendingPermission"
            >
              <pending
                :tabIndex="1"
                v-if="isRender[1]"
                :numberRowsPerPage="numberRowsPerPage"
              ></pending>
            </vs-tab>
            <vs-tab
              :label="$t('WaitingForCheckoutSubmission')"
              class="mt-1"
              v-if="waitingForCheckoutSubmissionPermission"
            >
              <waiting-for-checkout-submission
                :tabIndex="2"
                v-if="isRender[2]"
                :numberRowsPerPage="numberRowsPerPage"
              ></waiting-for-checkout-submission>
            </vs-tab>
            <vs-tab
              :label="$t('Processing')"
              class="mt-1"
              v-if="processingPermission"
            >
              <processing
                :tabIndex="3"
                v-if="isRender[3]"
                :numberRowsPerPage="numberRowsPerPage"
              ></processing>
            </vs-tab>
            <vs-tab
              :label="$t('Processed')"
              class="mt-1"
              v-if="processedPermission"
            >
              <processed
                :tabIndex="4"
                v-if="isRender[4]"
                :numberRowsPerPage="numberRowsPerPage"
              ></processed>
            </vs-tab>
            <vs-tab
              :label="$t('Rejected')"
              class="mt-1"
              v-if="rejectedPermission"
            >
              <rejected
                :tabIndex="5"
                v-if="isRender[5]"
                :numberRowsPerPage="numberRowsPerPage"
              ></rejected>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import WaitingForCheckoutSubmission from "./WaitingForCheckoutSubmission.vue";
import Pending from "./Pending.vue";
import WaitingForDischargePermissionSubmission from "./WaitingForDischargePermissionSubmission.vue";
import Processing from "./Processing.vue";
import Processed from "./Processed.vue";
import Rejected from "./Rejected.vue";
import SecurityService from "../../../auth/SecurityService.js";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "warehouseManagement_DischargePermission_Index",
  components: {
    WaitingForDischargePermissionSubmission,
    Pending,
    WaitingForCheckoutSubmission,
    Processing,
    Processed,
    Rejected
  },
  data() {
    return {
      permission120: "CreateDischargePermission",
      waitingForDischargePermissionSubmissionPermission: true,
      pendingPermission: true,
      waitingForCheckoutSubmissionPermission: true,
      processingPermission: true,
      processedPermission: true,
      rejectedPermission: true,
      isRender: [],
      referencePageInfo: {},
      numberRowsPerPage: "",
      tabIndex: 0
    };
  },
  created() {
    var permissionList = SecurityService.permissionList.split(",");
    if (!permissionList.includes("GetAllDischargePermissionWithoutItems")) {
      this.processedPermission = false;
      this.rejectedPermission = false;
      this.processingPermission = false;
      this.waitingForCheckoutSubmissionPermission = false;
    }
    if (!permissionList.includes("GetAllStockDraftOrderByState")) {
      this.waitingForDischargePermissionSubmissionPermission = false;
      this.pendingPermission = false;
    }
  },
  mounted() {
    this.onRender = Array(6).fill(false);
    setTimeout(() => {
      if (this.$route.query.referencePageInfo) {
        this.referencePageInfo = this.$route.query.referencePageInfo;
        this.$refs.Tabs.value = this.referencePageInfo.tabIndex;
        this.numberRowsPerPage = this.referencePageInfo.numberRowsPerPage;
      }
      this.isRender = Array(6).fill(true);
    }, 150);
  }
};
</script>
